import React from 'react';
import { EVBox, EVTypography } from '@eagleview/ev-comp-library';
import { func, string, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { REPORT_OPTIONS } from '../../../../constants';
import ReportRadio from './ReportRadio';
import useStyles from './ReportRadio.styles';
import { isSharedUrl } from '../../../../utils/utils';

const ReportRadioSection = ({
  selectedOption,
  handleRadioSelectChange,
  leftOffset,
  disabled,
}) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const isDisabled = disabled || isSharedUrl();

  return (
    <EVBox
      className={styles.radioSection}
      marginLeft={leftOffset}
    >
      <EVTypography className={styles.radioSectionLabel}>
        {t('report.jobtype')}
      </EVTypography>
      <EVBox className={styles.radioGroup}>
        <ReportRadio
          checked={selectedOption === REPORT_OPTIONS.CLAIM}
          handleRadioSelectChange={handleRadioSelectChange}
          radioValue={REPORT_OPTIONS.CLAIM}
          radioLabel={t('report.jobtype.claims')}
          disabled={isDisabled}
        />
        <ReportRadio
          checked={selectedOption === REPORT_OPTIONS.UNDERWRITING}
          handleRadioSelectChange={handleRadioSelectChange}
          radioValue={REPORT_OPTIONS.UNDERWRITING}
          radioLabel={t('report.jobtype.underwriting')}
          disabled={isDisabled}
        />
      </EVBox>
    </EVBox>
  );
};

ReportRadioSection.propTypes = {
  selectedOption: string.isRequired,
  handleRadioSelectChange: func.isRequired,
  leftOffset: string.isRequired,
  disabled: bool,
};

ReportRadioSection.defaultProps = {
  disabled: false,
};

export default ReportRadioSection;
